module.exports = __webpack_public_path__ + "d664201f/img/arrow-share-icon.00a12c29.svg";